import { configureStore } from "@reduxjs/toolkit";
import { combineReducers } from 'redux';
import { persistStore, persistReducer } from 'redux-persist'
import storage from 'redux-persist/lib/storage' // defaults to localStorage for web
import navbarSlice from "./navbarSlice";

const persistConfig = {
    key: 'root',
    storage,
}
const rootReducer = combineReducers({
    navbar: navbarSlice
});
const persistedReducer = persistReducer(persistConfig, rootReducer)
let store = configureStore({ reducer: persistedReducer })
let persistor = persistStore(store)

export { store, persistor }